import { Link } from "@/lib/router-compat";
import { heroPhotos, heroPhotoAlts, heroPhotoFallback, heroPhotoFallbackAlts } from "@/lib/heroImages";

export interface HubChild {
  /** child page slug — used to look up the shared photo map */
  slug: string;
  title: string;
  desc: string;
  href: string;
}

/**
 * Phase 3b child-service list — two-column rows, 120×90 thumbnail on the left,
 * child H2 in Barlow 700 18px, one-line description, thin rule between rows.
 * The whole row is the link. No icons.
 */
const HubChildList = ({ items, basePath }: { items: HubChild[]; basePath: string }) => (
  <div className="grid gap-x-8 md:grid-cols-2">
    {items.map((item, i) => {
      const image = heroPhotos[item.slug];
      const fallbackImage = !(item.slug in heroPhotos) ? heroPhotoFallback[basePath] : undefined;
      const imageAlt = image
        ? heroPhotoAlts[item.slug] || ""
        : fallbackImage
          ? heroPhotoFallbackAlts[basePath] || ""
          : "";
      return (
      <Link
        key={item.href}
        to={item.href}
        className="group flex gap-4 border-b border-border py-3 hover:bg-secondary/40"
      >
        {(image || fallbackImage) && (
          <img
            src={image || fallbackImage}
            alt={imageAlt}
            aria-hidden={imageAlt ? undefined : true}
            width="120"
            height="90"
            loading="lazy"
            decoding="async"
            fetchPriority={i < 6 ? "low" : undefined}
            className="h-[90px] w-[120px] flex-none rounded-[4px] object-cover"
          />
        )}
        <div className="min-w-0">
          <h2 className="font-heading text-[18px] font-bold leading-snug group-hover:text-primary">{item.title}</h2>
          <p className="mt-1 font-body text-[14px] leading-[1.6] text-muted-foreground">{item.desc}</p>
        </div>
      </Link>
      );
    })}
  </div>
);

export default HubChildList;
